// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"40":"c97456786e6aa84fe3de04095b50d7214b67ac20","415":"component---src-pages-404-jsx","615":"component---src-pages-storyblok-preview-jsx"}[chunkId] || chunkId) + "-" + {"40":"4dcc00ccc499380fdbf6","415":"8b8a9053b444fafea036","454":"544330831571deabed71","615":"fbbcfa77f8883443f037"}[chunkId] + ".js";
};